import { publicAxios } from '@/common/api/axios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation } from '@tanstack/react-query'

interface UseOAuthGoogleLoginParams {
  code: string | null
}

interface UseOAuthGoogleLoginProps {
  onSuccess?: (response: any) => void;
  onError?: (error: ErrorResponse) => void;
}

const useOAuthGoogleLogin = ({ onSuccess, onError }: UseOAuthGoogleLoginProps) => {
  return useMutation({
    mutationFn: async ({ code }: UseOAuthGoogleLoginParams) => {
      const { data, headers } = await publicAxios.post('/authentication/oauth/google', { code });

      return { infos: data, accessToken: headers?.authorization }
    },
    onSuccess,
    onError,
  });
}

export default useOAuthGoogleLogin;
